import { type ReactNode } from 'react';
import { ThreadsApiContext } from './ThreadsApiContext';
import type { ThreadsApiClient } from './types';

export function ThreadsApiProvider({
  client,
  children,
}: {
  client: ThreadsApiClient;
  children: ReactNode;
}) {
  return (
    <ThreadsApiContext.Provider value={client}>{children}</ThreadsApiContext.Provider>
  );
}
